import type { ColumnConfig } from '../../../hooks/useColumnConfig';

export const DATA_LIBRARY_COLUMNS: ColumnConfig[] = [
  // Identity
  { id: 'email', label: 'Email', visible: true, sortable: true, groupable: false },
  { id: 'first_name', label: 'First Name', visible: true, sortable: true, groupable: false },
  { id: 'last_name', label: 'Last Name', visible: true, sortable: true, groupable: false },
  { id: 'preferred_name', label: 'Preferred Name', visible: false, sortable: true, groupable: false, exportKey: 'preferred_name' },

  // Cohort context
  { id: 'cohort_name', label: 'Cohort', visible: true, sortable: true, exportKey: 'cohort_name' },
  { id: 'cohort_health', label: 'Cohort Health', visible: false, sortable: false, groupable: false, exportKey: 'cohort_health' },
  { id: 'partner_name', label: 'Partner', visible: false, sortable: true },
  { id: 'status', label: 'Status', visible: true, sortable: true },

  // Group & Coach
  { id: 'group_name', label: 'Group', visible: true, sortable: true },
  { id: 'coach_name', label: 'Coach', visible: true, sortable: true, exportKey: 'coach_name' },
  { id: 'timeslot', label: 'Timeslot', visible: false, sortable: false, groupable: false, exportKey: 'timeslot' },

  // Work info
  { id: 'role', label: 'Role', visible: false, sortable: true },
  { id: 'business_unit', label: 'Department', visible: false, sortable: true },
  { id: 'location', label: 'Location', visible: false, sortable: true },
  { id: 'manager', label: 'Manager', visible: false, sortable: false, groupable: false },
  { id: 'level', label: 'Level', visible: false, sortable: false },
  { id: 'dnm', label: 'DNM', visible: false, sortable: false },

  // Engagement
  { id: 'attendance', label: 'Attendance %', visible: true, sortable: true, groupable: false, exportKey: 'attendance_percentage', numeric: 'percent' },
  // MED-1266 (AC12): marking coverage as its own column alongside the rate.
  { id: 'attendance_coverage', label: 'Attendance Coverage', visible: false, sortable: false, groupable: false, exportKey: 'attendance_coverage' },
  { id: 'attendance_detail', label: 'Attendance Detail', visible: true, sortable: false, groupable: false },
  { id: 'avg_engagement', label: 'Avg Engagement', visible: true, sortable: true, groupable: false, exportKey: 'avg_engagement', numeric: 'decimal' },
  { id: 'engagement_detail', label: 'Engagement Detail', visible: true, sortable: false, groupable: false },
  { id: 'personality_type', label: 'Personality Type', visible: false, sortable: true },

  // Flags
  { id: 'flags', label: 'Flags', visible: true, sortable: true, groupable: false },
  { id: 'flag_severity', label: 'Severity', visible: false, sortable: true, exportKey: 'flag_severity' },

  // Surveys
  { id: 'midpoint_completed', label: 'Midpoint', visible: true, sortable: false, groupable: false, exportKey: 'midpoint_completed' },
  { id: 'endpoint_completed', label: 'Endpoint', visible: true, sortable: false, groupable: false, exportKey: 'endpoint_completed' },
  { id: 'mid_satisfaction', label: 'Mid Satisfaction', visible: false, sortable: false, groupable: false, exportKey: 'mid_satisfaction' },
  { id: 'end_satisfaction', label: 'End Satisfaction', visible: false, sortable: false, groupable: false, exportKey: 'end_satisfaction' },
  { id: 'mid_coach_satisfaction', label: 'Mid Coach Satisfaction', visible: false, sortable: false, groupable: false, exportKey: 'mid_coach_satisfaction' },
  { id: 'end_coach_satisfaction', label: 'End Coach Satisfaction', visible: false, sortable: false, groupable: false, exportKey: 'end_coach_satisfaction' },

  // Communication
  { id: 'last_email_date', label: 'Last Email', visible: false, sortable: false, groupable: false, exportKey: 'last_email_date' },
  { id: 'enrolled_at', label: 'Enrolled', visible: false, sortable: true },

  // Intake
  { id: 'coaching_experience', label: 'Coaching Exp.', visible: false, sortable: false, groupable: true, exportKey: 'paperform_coaching_experience' },
  { id: 'coaching_value', label: 'Coaching Value', visible: false, sortable: false, groupable: true, exportKey: 'paperform_fast_forward' },
];

export const DEFAULT_VISIBLE_COLUMNS = DATA_LIBRARY_COLUMNS.filter(c => c.visible).map(
  c => c.id,
);
